import { configureStore } from "@reduxjs/toolkit"
import roomSlice from "./slices/roomSlice"
import userSlice from "./slices/userSlice"

let store = configureStore({
    reducer: {
        roomSlice: roomSlice,
        userSlice: userSlice,
    }
})

export default store